import React, {Component} from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import "bootstrap";

class MnTooltipIcon extends Component {
    constructor(props, context) {
        super(props, context);

        this.elem = React.createRef();
    }

    initializeBsTooltips = () => {
        $(this.elem.current).tooltip();
    };

    componentDidMount() {
        this.initializeBsTooltips();
    }

    render() {
        if (!this.props.text) {
            return null;
        }

        return (
            <i ref={this.elem}
               className={this.props.iconClass}
               data-toggle="tooltip"
               data-placement={this.props.placement}
               title={this.props.text}
            ></i>
        );
    }
}

MnTooltipIcon.propTypes = {
    text: PropTypes.string.isRequired,
    iconClass: PropTypes.string,
    placement: PropTypes.string
};

MnTooltipIcon.defaultProps = {
    iconClass: "fa fa-info-circle",
    placement: "top"
};

export default MnTooltipIcon;